/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AnalysisProcess } from "./AnalysisProcess";
import {
  AnalysisProcessFromJSON,
  AnalysisProcessFromJSONTyped,
  AnalysisProcessToJSON,
  AnalysisProcessToJSONTyped,
} from "./AnalysisProcess";

/**
 *
 * @export
 * @interface ApiGarAnalysisprocessesList200Response
 */
export interface ApiGarAnalysisprocessesList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGarAnalysisprocessesList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGarAnalysisprocessesList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGarAnalysisprocessesList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<AnalysisProcess>}
   * @memberof ApiGarAnalysisprocessesList200Response
   */
  results: Array<AnalysisProcess>;
}

/**
 * Check if a given object implements the ApiGarAnalysisprocessesList200Response interface.
 */
export function instanceOfApiGarAnalysisprocessesList200Response(
  value: object
): value is ApiGarAnalysisprocessesList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGarAnalysisprocessesList200ResponseFromJSON(
  json: any
): ApiGarAnalysisprocessesList200Response {
  return ApiGarAnalysisprocessesList200ResponseFromJSONTyped(json, false);
}

export function ApiGarAnalysisprocessesList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGarAnalysisprocessesList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(AnalysisProcessFromJSON),
  };
}

export function ApiGarAnalysisprocessesList200ResponseToJSON(
  json: any
): ApiGarAnalysisprocessesList200Response {
  return ApiGarAnalysisprocessesList200ResponseToJSONTyped(json, false);
}

export function ApiGarAnalysisprocessesList200ResponseToJSONTyped(
  value?: ApiGarAnalysisprocessesList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(AnalysisProcessToJSON),
  };
}
